import styled from 'react-emotion'
import { Row } from './Box'
import { colors } from './styleguide'
import rgba from 'hex-to-rgba'

export default styled(Row)`
  width: 100%;
  background-color: ${rgba(colors.background, 0.95)};
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  border-bottom: 1px solid ${colors.foreground};
`



// WEBPACK FOOTER //
// ../styleguide/src/Topbar.jsx